import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import Hero from "../components/hero";
import TrustBar from "../components/trustbar";
import SchoolTrust from "../components/school_trust";
import XLPOffers from "../components/xlp_offers";
import ContactForm from "../components/contact_form";

class HomeScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <div>
          <Header isLoggedIn={isLoggedIn} />

          <Hero
            subtitle="Explore Interests, Develop Skills, Create Impact"
            title={
              <>
                Future-Ready
                <br />
                Learning, Today.
              </>
            }
            description="We work with visionary school leaders to integrate STEAM, Finance, Arts, Design, Aerospace, Coding, and BEAM—strengthening school reputation, engaging parents, and preparing students for tomorrow."
            buttonText="Explore Programs"
            buttonLink="/xlp_for_schools_screen"
            imageSrc="assets-webp/misc/grad-hats-air.webp"
            background="linear-gradient(to bottom, #f0f4f8 0%, #ffffff 100%)" // Overriding the default background
          />

          <TrustBar />

          <SchoolTrust />

          <XLPOffers
            title="What XLP Offers"
            description="XLP is packaged with Elective Skill Areas(ESA), modules which can be chosen by the school as per their vision & interest levels and design a customize curriculum."
            imageSrc="assets-webp/flowcharts/ESA-flowchart.webp"
          />

          {/* PROCESS SECTION START */}
          <section className="py-5 bg-white">
            <div className="container py-lg-5 text-center">
              <div className="row justify-content-center mb-5">
                <div className="col-lg-10">
                  <h2 className="display-6 text-dark mb-3">
                    Simple. Proven. Reliable. For Schools
                  </h2>
                  <p className="text-secondary lead">
                    Our process is deliberately simple. We follow a clear set of
                    time-tested steps that schools can rely on—structured,
                    proven, and built for operational excellence.
                  </p>
                </div>
              </div>
              <div className="mb-5 mx-auto" style={{ maxWidth: "900px" }}>
                <img
                  src="/assets-webp/flowcharts/process-flowchart.webp"
                  alt="XLP 9-Step Process Timeline"
                  className="img-fluid"
                />
              </div>
              <div className="d-flex justify-content-end">
                <a href="#" className="btn btn-brand px-4 py-2">
                  Explore Programmes &rarr;
                </a>
              </div>
            </div>
          </section>
          {/* PROCESS SECTION END */}

          <ContactForm />

          <Footer />
        </div>
      </>
    );
  }
}

export default HomeScreen;
